import React from 'react';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { useController } from './provider';
import { CancelButton } from './cancel-button';
import { ConfirmButton } from './confirm-button';

export const EditMenu = () => {
    const { isEditing } = useController();
    return !isEditing ? null : (
        <ButtonGroup aria-label="Basic example">
            <CancelButton />
            <ConfirmButton />
        </ButtonGroup>
    );
};
